import React, { FunctionComponent } from 'react'
import styles from './Splitter.module.sass'
import clsx from 'clsx'

interface Props {
    full?: boolean,
}

const Splitter: FunctionComponent<Props> = ({full}) => <div className={clsx(styles.splitter, {[styles.full]: full})}/>

export default Splitter